module.exports = __webpack_public_path__ + "static/img/page-top-bg.714df15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/page-top-bg.png
// module id = t98E
// module chunks = 1